import api from './api';

class AnextService {
  bind() {
    return api.post('/merchant/anext/bind');
  }
}

export default new AnextService();
